<template>
    <v-dialog
        v-model="isDialogOpen"
        width="550"
    >
        <v-card>
            <v-toolbar
                flat
            >
                <v-toolbar-title class="pl-6 text-center">
                    <span class="font-weight-bold">{{ $t('specifyRateManually') }}</span>
                </v-toolbar-title>
                <v-toolbar-items class="pr-2 ml-auto">
                    <v-btn
                        icon
                        @click.native="$emit('close')"
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-container>
                <v-row>
                    <v-col class="px-0 px-md-16 text-center">
                        <span class="">
                            {{ $t('recommendedRateByManufacturer')}}: {{ $t('fromOt').toLowerCase() }} {{ recommendedMin }} {{ $t('before').toLowerCase() }} {{ recommendedMax }} {{ unitName }}
                        </span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4"></v-col>
                    <v-col>
                        <v-text-field
                            v-model="tempRate"
                            :label="$t('enterRate')"
                            type="number"
                            min="0"
                            dense
                            hide-details
                        ></v-text-field>
                    </v-col>
                    <v-col cols="4"></v-col>
                </v-row>
            </v-container>
            <v-card-actions class="pb-4">
                <v-spacer></v-spacer>
                <v-btn
                    color="main--yellow white--text"
                    dark
                    depressed
                    @click="sendRate"
                >
                    OK
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import DialogRemote from "../../mixins/DialogRemote";

export default {
    name: "ProductUsageRateDialog",
    mixins: [ DialogRemote ],
    props: [
        'rate',
        'recommendedMin',
        'recommendedMax',
        'unitName'
    ],
    data() {
        return {
            tempRate: this.rate,
        }
    },
    methods: {
        sendRate() {
            this.$emit('sendRate', this.tempRate);
            this.$emit('close')
        }
    },
    watch: {
        rate(val) {
            this.tempRate = val;
        }
    }
}
</script>

<style scoped>

</style>
